import type { VacationRequest } from '@domain/entities/VacationRequest';

/**
 * Si la solicitud espera la respuesta de quien fue nombrado respaldo.
 *
 * La ausencia del campo cuenta como pendiente, y ahí es donde esto se separa de
 * `awaitsReplacement`, que mira lo mismo desde el otro lado del escritorio.
 *
 * Una solicitud anterior a esta función nombra respaldo y no trae respuesta
 * porque cuando se envió no había dónde darla. Para quien fue nombrado eso es
 * justo lo que hay que contestar —descartarlas dejó a la QA sin ver la
 * solicitud que la nombraba, que era el problema que la función venía a
 * resolver—. Para el líder no lo es: bloquear esas mismas solicitudes habría
 * dejado sin aprobar todo lo que llevaba días en el tablero el día del
 * despliegue.
 *
 * El servidor ya lee la ausencia como `pending`; esto es la otra mitad.
 */
export const awaitsMyAnswer = (
  request: Pick<VacationRequest, 'replacementPersonId' | 'replacementDecision'>,
): boolean =>
  request.replacementPersonId !== null &&
  (request.replacementDecision === null || request.replacementDecision === 'pending');
